<template>
  <div class="d-inline-flex m-1" v-if="$can('update_all-time_offs')">
    <ViewTimeOffModal
      v-if="showForm"
      :value="true"
      :title="titleText"
      :mode="mode"
      :timeOff="timeOff"
      :isLoading="getIsModalLoading"
      @approve="approveTimeOff"
      @decline="declineTimeOff"
      @edit="handleEditFromView"
      @input="onModalClose"
    />
    <TimeOffFormModal
      v-if="showEditForm"
      v-model="showEditForm"
      :dataProps="form"
      :mode="editMode"
      :modal="true"
      :show-preloader="true"
      @save="editTimeOff"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import ViewTimeOffModal from '../components/modals/ViewTimeOffModal.vue'
import TimeOffFormModal from '../components/modals/TimeOffFormModal.vue'
import TimeOffs from '../mixins/TimeOffs'

export default {
  name: 'TimeOffApprove',
  components: { ViewTimeOffModal, TimeOffFormModal },
  mixins: [TimeOffs],
  props: {
    value: {}
  },
  data () {
    return {
      mode: 'view',
      showEditForm: false,
      editMode: 'edit',
      form: {}
    }
  },
  computed: {
    ...mapGetters({
      getIsModalLoading: 'finances/getIsModalLoading'
    }),
    titleText () {
      if (this.mode === 'approve' && this.timeOff) {
        const isEdited = this.timeOff.created_at !== this.timeOff.updated_at
        return 'Approve time off' + (isEdited ? ' (last updated at ' + this.$moment(this.timeOff.updated_at).format('YYYY-MM-DD HH:mm') + ')' : '')
      }
      return 'View time off'
    }
  },
  watch: {
    showEditForm (newValue) {
      // When the edit modal closes, remove the URL parameter
      if (!newValue) {
        this.removeApprovedTimeOffIdFromUrl()
      }
    }
  },
  async mounted () {
    await this.loadTimeOff(this.value)
    if (this.isApprover) {
      this.mode = 'approve'
    } else {
      this.mode = 'view'
    }
  },
  methods: {
    onModalClose (value) {
      if (!value) {
        this.removeApprovedTimeOffIdFromUrl()
      }
    },
    removeApprovedTimeOffIdFromUrl () {
      const currentQuery = { ...this.$route.query }
      delete currentQuery.approved_time_off_id

      this.$router.replace({
        path: this.$route.path,
        query: currentQuery
      }).catch(() => {
        // Ignore NavigationDuplicated errors
      })
    },
    handleEditFromView () {
      this.showForm = false
      this.form = cloneDeep(this.timeOff)
      this.showEditForm = true
    },
    editTimeOff (data) {
      this.setIsModalLoading(true)
      this.$api.timeOffs.editTimeOff(data)
        .then(({ data }) => {
          this.$snotify.success(
            'Time off successfully saved',
            'Success',
            this.$store.state.snotify
          )
          this.showEditForm = false
          this.form = {}
          this.timeOff = cloneDeep(data)
          // Reload the time off to get updated data
          this.loadTimeOff(this.value)
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.setIsModalLoading(false)
        })
    }
  }
}
</script>
